module.exports = __webpack_public_path__ + "4859c90632363192cd360c48aa54954a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/spiral-notebook-s.png
// module id = 2612
// module chunks = 0